import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "shift__vacation-item item-layout"
}
const _hoisted_2 = {
  key: 0,
  class: "item-layout-title"
}
const _hoisted_3 = {
  key: 1,
  class: "item-layout-controls"
}

import VitaIcon from "@/components/UI/VitaIcon.vue";
import VitaButton from '@/components/UI/VitaButton.vue';
import { checkUnsavedChanges } from "@/utils/main";
import { vacationTypes } from "@/utils/vacation";
import store from "@/store";
import { computed, ref } from 'vue';
import { VacationItem } from '@/types';

interface Props {
  vacation: VacationItem;
  zupGuid: string;
  visible: boolean;
  visibleUpdate: string | null;
  userCanEdit: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaVacationItem',
  props: {
    vacation: {},
    zupGuid: {},
    visible: { type: Boolean },
    visibleUpdate: {},
    userCanEdit: { type: Boolean }
  },
  emits: ["update:visible", "update:visibleUpdate"],
  setup(__props: any, { emit: __emit }) {



const inProcess = ref(false);
const openConfirmModal = ref(false);
const emit = __emit;

const openVacationUpdate = (vacationId: string | null | undefined) => {
  if (!vacationId) return
  emit("update:visible", true);
  emit("update:visibleUpdate", vacationId);
};

const loader = computed<boolean>(() => {
  return store.getters["user/loader"];
});

const cancelVacation = async (id: string | null | undefined, zupGuid: string) => {
  if (!id) return

  try {
    openConfirmModal.value = false;
    inProcess.value = true;
    !loader.value ? store.commit("user/setLoader", true) : null;
    const statusCode = await store.dispatch("data/cancelVacation", {
      id,
      zupGuid,
    });
    if (statusCode >= 400) return false;

    // noinspection ES6MissingAwait
    store.dispatch("data/getFondWorkTime");
    // noinspection ES6MissingAwait
    store.dispatch("data/getFondWorkTimeHuman");
    await store.dispatch("data/getPharmSchedule");
    await store.dispatch("data/getAdminShift");
    // Обновление расписания для незаполненных дней
    await store.dispatch("data/getTimeScheduleDetails");
    await store.dispatch("data/getTimeSchedule");

    // Закрытие окна
    store.commit("data/closeCreateShift");
    checkUnsavedChanges();
  } catch (e) {
    console.error(e);
  } finally {
    inProcess.value = false;
    store.commit("user/setLoader", false);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_vita_modal = _resolveComponent("vita-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.vacation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.vacation.type)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(vacationTypes)[__props.vacation.type].title), 1))
            : _createCommentVNode("", true),
          (__props.userCanEdit && __props.vacation.isInternal && __props.vacation.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openVacationUpdate(__props.vacation.id))),
                  type: "button",
                  "data-qa": "vacation-item-button-edit"
                }, [
                  _createVNode(VitaIcon, { name: "pencil" })
                ]),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openConfirmModal.value = true)),
                  type: "button",
                  "data-qa": "vacation-item-button-cancel"
                }, [
                  _createVNode(VitaIcon, { name: "cross-red" })
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (openConfirmModal.value)
      ? (_openBlock(), _createBlock(_component_vita_modal, {
          key: 1,
          title: "Вы действительно хотите отменить НН?"
        }, {
          default: _withCtx(() => [
            _createVNode(VitaButton, {
              color: "red",
              width: "inline",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelVacation(__props.vacation.id, __props.zupGuid))),
              disabled: inProcess.value,
              "data-qa": "vacation-item-button-cancel-confirm"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("Да", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(VitaButton, {
              color: "blue",
              width: "inline",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openConfirmModal.value = false)),
              disabled: inProcess.value,
              "data-qa": "vacation-item-button-cancel-reject"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("Нет", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})